import { Component, ContentChild, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { MenuItemDefinition } from '../../../core/model/menu-item-definition';
import { FormHeaderStateService } from '../../service/form-header-state.service';

export type QuickAccessItem = {
  field: string;
  value: string;
};

@Component({
    selector: 'app-form-header',
    templateUrl: './form-header.component.html',
    styleUrls: ['./form-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormHeaderComponent implements OnDestroy, OnInit {
  constructor(
    _route: ActivatedRoute,
    private formHeaderStateService: FormHeaderStateService
  ) {
    this._subscription = _route.data.subscribe(data => {
      if (data) {
        this.header = data.header;
      }
    });
  }

  private _subscription: Subscription;
  private _destroy$ = new Subject<void>();
  header: string;
  isSaveDisabled: boolean = false;

  @Output() onCancel = new EventEmitter();
  @Output() onSave = new EventEmitter();
  @Input() params: any;
  @Input() showSave: boolean = true;
  @Input() cancelText: string = 'FORM_HEADER.CANCEL_BTN'; // (this is actually the "show list" button)
  @Input() menuDefinition: MenuItemDefinition[];
  @Input() quickAccessItems: QuickAccessItem[];
  @Input() contextInfo: string;
  @Input() compact = false;
  @Input() tabsFollow = false;

  @ContentChild(TemplateRef) contentTemplate;

  public get cancelVisible(): boolean {
    return this.onCancel.observed;
  }

  public get saveVisible(): boolean {
    return this.showSave && this.onSave.observed;
  }

  public cancelClicked() {
    this.onCancel.emit();
  }

  public saveClicked() {
    this.onSave.emit();
  }

  public enableSaveButton() {
    this.isSaveDisabled = false;
  }

  public disableSaveButton() {
    this.isSaveDisabled = true;
  }

  public get helpButtonsVisible() {
    return this.menuDefinition || this.saveVisible || this.cancelVisible;
  }

  public get hasQuickAccessInfo(): boolean {
    return !!this.quickAccessItems;
  }

  public get quickAccessInfoString(): string {
    return this.quickAccessItems ? this.quickAccessItems.map(x => x.value).join(', ') : null;
  }

  showInfo: boolean;
  public toggleShowInfo() {
    this.showInfo = !this.showInfo;
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
    this._subscription = null;
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit() {
    if (this.saveVisible) {
      this.formHeaderStateService.saveButtonEnabled$.pipe(takeUntil(this._destroy$)).subscribe(enabled => {
        if (enabled) {
          this.enableSaveButton();
        } else {
          this.disableSaveButton();
        }
      });
    }
  }
}
